import { render } from "./TransportationHome.vue?vue&type=template&id=af5d9b5e&ts=true"
import script from "./TransportationHome.vue?vue&type=script&lang=ts"
export * from "./TransportationHome.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\winserverroot\\Downloads\\ソース\\netstore-browser-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__